<template>
    <filters-block @toggle="$emit('toggle')" :collapse="collapse" :title="localizeList.hotelType" :open="open">
        <div class="headlineCombinationInfo" v-show="hideHotelTypeCombination">
            <div class="iconCombination"
                 @mouseleave="hidePopover()"
                 @mouseenter="showPopover(localizeList.hotelTypeCombinationDescr, $event)">
                <icon name="help" width="14px" height="14px" fill="var(--primary-color)" />
            </div>
            <span :title="localizeList.hotelTypeCombinationUpper">
                {{localizeList.hotelTypeCombinationUpper}}
            </span>
            <checkbox class="chekboxCombinationInfo" 
                      v-model="tourHotelTypeCombination" 
                      @change="changeTourHotelTypeCombination($event)"
                      no-gap />
        </div>
        <div class="input-headline-checkbox-container">
            <base-input v-model="search" 
                        class="search"
                        :placeholder="localizeList.titleUpper"
                        clearable>
              <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>
            </base-input>
            <div v-if="presentHotelTypeList.length" class="common-input-headline-checkbox-container">
              <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
              <checkbox v-model="checkHotelTypeCheckbox"
                        @change="changeTourHotelType('all', $event)"
                        no-gap />
            </div>
          </div>
        <div class="hotel-type-list">
            <div v-for="(item, key) in presentHotelTypeList"
                 :key="key">
                <div v-if="item.isShow && !(item.isDisabled && !tourHotelTypeChecked[item.key])" class="hotel-type-item">
                    <checkbox v-model="tourHotelTypeChecked[item.key]"
                              @change="changeTourHotelType(item.key, $event)">
                        <div class="align-center ellipsis">
                            <img width="20px" height="20px" :src="getHotelTypeIcons(item.key)"
                                 class="hotel-type-icon mr-5"/>
                            <span class="ellipsis" :title="item.name">{{item.name}}</span>
                        </div>
                    </checkbox>
                </div>
            </div>
            <div v-show="!presentHotelTypeList.length">
                <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
            </div>
        </div>
    </filters-block>
</template>

<script>
    import {bus} from '@/main'
    import FiltersBlock from "./filtersBlock";
    export default {
        name: "hotelTypes",
        props: {
            tourHotelTypeList: {
                type: Array,
                required: true
            },
            tourHotelTypeChecked: {
                type: Object,
                required: true
            },
            collapse: {
                type: Number,
                default: 0
            },
            hideHotelTypeCombination: {
                type: Boolean,
                default: false
            },
            tourHotelTypeCombination: {
                type: Boolean,
                default: false
            },
            headlineCheckbox: {
                type: Boolean,
                default: false
            },
            open: {
                type: Number,
                default: 0
            },
        },
        components: {
            FiltersBlock
        },
        computed: {
            presentHotelTypeList() {
                let res = this.tourHotelTypeList;
                if (this.search)
                    res = res.filter(x => x.name.toLowerCase().includes(this.search.toLowerCase()));

                return res
            },
            checkHotelTypeCheckbox: {
                get() {
                    return this.hotelTypeCheckbox
                },
                set(value) {
                    this.hotelTypesCheckbox = value
                    this.$parent.$parent.$parent.headlineCheckbox.hotelType = value
                }
            }
        },
        data() {
            return {
                search: "",
                hotelTypeCheckbox: false
            }
        },
        created() {
            bus.$on("left-filters-reset-search-for-hotels", () => {
                this.search = "";
            })
        },
        methods: {
            changeTourHotelType(key, e) {
                this.$parent.$parent.filtersLoader = true;
                this.$parent.$parent.$parent.changeTourHotelType(key, e)
            },
            getHotelTypeIcons(key) {
                return this.$parent?.$parent?.$parent?.getHotelTypeIcons(key) || ""
            },
            changeTourHotelTypeCombination(e) {
                this.$parent.$parent.$parent.changeTourHotelTypeCombination(e)
            },
            showPopover(text, e) {
                this.$parent.$parent.$parent.showPopover(text, e)
            }
        },
        watch: {
            headlineCheckbox: {
                immediate: true,
                handler(value) {
                    this.hotelTypeCheckbox = value
                }
            }
        }
    }
</script>

<style scoped>

    .hotel-type-list {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 175px;
    }

    .vertical-filters .hotel-type-list {
        max-height: 340px;
    }

    .hotel-type-list .hotel-type-item {
        padding: 7px 0;
        display: flex;
        align-items: center;
    }

    .headlineCombinationInfo {
        font-weight: 500;
        display: flex;
        justify-content: end;
        align-items: center;
        gap: 5px;
        margin-bottom: 7px;
    }

    .chekboxCombinationInfo {
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        color: var(--dark-1-color);
    }

    .input-headline-checkbox-container {
      display: flex;
      justify-content: space-around;
      gap: 12px;
      align-items: center;
      margin-bottom: 20px;
    }

    .common-input-headline-checkbox-container {
      display: flex;
      gap: 5px;
    }

    .common-headline-checkbox {
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: var(--dark-1-color);
      white-space: nowrap;
    }
</style>